import { Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { AccordionProps } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { AccordionRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRule';
import { OrderSettingsRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/OrderSettingsRule/OrderSettingsRuleHeader';
import { withRow } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/withRow';
import {
  FulfillmentTypeSegmentedControl,
  FulfillmentTypeSegmentedControlProps,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/FulfillmentTypeSegmentedControl';
import { AvailableOrderTypesCheckbox } from 'src/components/oneCorp/features/MealCredit/common/formFields/Checkbox/AvailableOrderTypesCheckbox';

export type OrderSettingsRuleProps = Omit<AccordionProps, 'header' | 'body'>;

const FulfillmentTypeWithRow = withRow<FulfillmentTypeSegmentedControlProps>(
  FulfillmentTypeSegmentedControl
);

export function OrderSettingsRule({
  ...props
}: OrderSettingsRuleProps): JSX.Element {
  const {
    formValues: { hasLocation },
    corpDataValues: { groupOrderEnabled },
  } = useMealCreditFormData();

  return (
    <AccordionRule
      {...props}
      header={(isActive): JSX.Element => (
        <OrderSettingsRuleHeader isActive={isActive} />
      )}
      body={(): JSX.Element => (
        <>
          {hasLocation && (
            <Stack y="sm">
              <FulfillmentTypeWithRow
                id="fulfillmentType"
                name="fulfillmentType"
              />
            </Stack>
          )}
          <AvailableOrderTypesCheckbox
            hasGroupOption={groupOrderEnabled}
            id="availableOrderTypes"
            name="availableOrderTypes"
          />
        </>
      )}
    />
  );
}
